const PRODUCT_PREFIX = 'driver_car_';
export default {
  FB_AD                   : `${PRODUCT_PREFIX}fb_ad`,
  FB_FBCLID               : `${PRODUCT_PREFIX}fbclid`,
  FB_ENTRY_TIMESTAMP      : `${PRODUCT_PREFIX}entry_timestamp`,
  RETRY_PAYMENT_TIME      : `${PRODUCT_PREFIX}retry_payment_time`,
  ANONYMOUS_USER_ID       : `${PRODUCT_PREFIX}anon_user_id`,
  LAST_PAGE_VISITED       : `${PRODUCT_PREFIX}lastPageVisited`,
}
